import React from 'react'
import Header from './Header';
import Footer from './Footer';
import Page from './Page';
import CssBaseline from '@mui/material/CssBaseline';
import HeaderEmployee from './HeaderEmployee';


class BasicEmployee extends React.Component{
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render(){
        const { page } = this.props;       
        return(
            <div >
                <CssBaseline />
                <HeaderEmployee currentPage={page}/>
                <Page>
                    {this.props.children}
                </Page>
                {/* <Footer {...this.props} /> */}
            </div>
        )
    }
}

export default BasicEmployee;
